import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Worker, Viewer } from '@react-pdf-viewer/core';

export default function ViewDocument({
  onClose,
  ...document
}: {
  onClose: () => unknown;
  name?: string;
  url?: string;
}) {
  return (
    <Dialog
      onClose={onClose}
      open={!!document?.url}
      className="md:w-3/4 md:h-4/5"
    >
      <div className="p-4 h-full flex overflow-auto flex-col">
        <div className="mb-4 flex justify-center items-center">
          <h4 className="m-0 grow text-center text-2xl font-bold">
            {document?.name || "Document"}
          </h4>
          <button className="text-xl" onClick={onClose}>
            <i className="fa fa-close"></i>
          </button>
        </div>
        <div className="w-full grow overflow-auto">
          {document?.url?.endsWith("pdf") ? (
            <div style={{ height: '100%', width: '100%' }}>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}>
                <Viewer fileUrl={
                 (document?.url ?? "https://pdfobject.com/pdf/sample.pdf") +
                 "#toolbar=0&zoom=full"
               } />
            </Worker>
        </div>
            // <iframe
            //   title="PDF Viewer"
            //   className="rounded-b-3xl w-full h-full"
            //   src={
            //     (document?.url ?? "https://pdfobject.com/pdf/sample.pdf") +
            //     "#toolbar=0&zoom=full"
            //   }
            // />
          ) : (
            <img
              src={String(document?.url)}
              className="object-contain mx-auto"
              alt="Document"
            ></img>
          )}
        </div>
      </div>
    </Dialog>
  );
}
